export const BUTTON_THEME = {
  pddng: {
    v: {
      sm: '2px',
      md: '3px',
      lg: '4px',
      xl: '6px',
    },
    h: {
      sm: '7px',
      md: '9px',
      lg: '11px',
      icon: {
        s: '3px',
        m: '5px',
        l: '7px',
        xl: '9px',
      },
    },
  },
  gap: {
    sm: '2px',
    md: '2px',
    lg: '4px',
    'sm-both': '8px',
    'md-both': '10px',
    'lg-both': '12px',
  },
  tagLeftMargin: {
    sm: '2px',
    md: '4px',
    lg: '4px',
  },
  radius: {
    sm: '8px',
    md: '8px',
    lg: '8px',
    xl: '10px',
  },
  minSize: {
    sm: '24px',
    md: '28px',
    lg: '32px',
    xl: '44px',
  },
  iconSize: {
    sm: 16,
    md: 16,
    lg: 16,
    xl: 24,
  },
};
